import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("awc_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // X-Actor: attach the logged-in user's email so the backend audit trail knows WHO did what
    try {
        const raw = localStorage.getItem("awc_user");
        if (raw) {
            const u = JSON.parse(raw);
            const actor = u?.email || u?.name;
            if (actor) config.headers["X-Actor"] = actor;
        }
    } catch (_) { /* ignore parse errors */ }
    return config;
});
